export default {
  "instagram-downloader": {
    title: "इंस्टाग्राम डाउनलोडर — इंस्टाग्राम वीडियो और फोटो मुफ्त डाउनलोड करें",
    h1: "इंस्टाग्राम डाउनलोडर",
    desc: "कोई भी इंस्टाग्राम वीडियो, फोटो, रील या कैरोसेल पोस्ट मुफ्त में डाउनलोड करें। कोई लॉगिन नहीं, कोई वॉटरमार्क नहीं, iPhone, Android और PC पर काम करता है।",
    metaDesc: "मुफ्त इंस्टाग्राम डाउनलोडर — इंस्टाग्राम वीडियो, फोटो, रील्स और कैरोसेल पोस्ट HD में सेव करें। कोई वॉटरमार्क नहीं, कोई लॉगिन नहीं।",
    keywords: "instagram downloader, instagram वीडियो डाउनलोड करें, instagram फोटो डाउनलोडर, मुफ्त instagram downloader",
    faq: [
      { q: "मैं इंस्टाग्राम वीडियो कैसे डाउनलोड करूं?", a: "इंस्टाग्राम वीडियो का URL कॉपी करें, InstantSaver में पेस्ट करें, Preview पर क्लिक करें, फिर Download पर क्लिक करें। आपका वीडियो कुछ ही सेकंड में सेव हो जाएगा।" },
      { q: "क्या मैं इंस्टाग्राम फोटो डाउनलोड कर सकता हूं?", a: "हां। पोस्ट का URL पेस्ट करें, InstantSaver खुद पहचान लेगा कि यह फोटो है या वीडियो और सही डाउनलोड बटन दिखाएगा।" },
      { q: "क्या मुझे अकाउंट बनाना होगा?", a: "कभी भी अकाउंट या लॉगिन की जरूरत नहीं है। InstantSaver पूरी तरह मुफ्त और अनाम है।" },
      { q: "क्या डाउनलोड की गई फाइलों पर वॉटरमार्क होता है?", a: "नहीं। फाइलें सीधे इंस्टाग्राम के CDN से उनकी मूल क्वालिटी में डाउनलोड होती हैं — कोई वॉटरमार्क नहीं जोड़ा जाता।" },
    ],
    featureTitle: "आप क्या डाउनलोड कर सकते हैं",
    features: [
      { icon: "🎬", text: "इंस्टाग्राम रील्स — फुल HD वीडियो" },
      { icon: "🖼️", text: "फोटो और फीड पोस्ट" },
      { icon: "🗂️", text: "कैरोसेल पोस्ट — हर इमेज अलग-अलग" },
      { icon: "📺", text: "IGTV लंबे वीडियो" },
      { icon: "👤", text: "मूल क्वालिटी में प्रोफ़ाइल पिक्चर" },
    ],
  },

  "reels-downloader": {
    title: "इंस्टाग्राम रील्स डाउनलोडर — रील्स मुफ्त HD में सेव करें",
    h1: "इंस्टाग्राम रील्स डाउनलोडर",
    desc: "किसी भी इंस्टाग्राम रील को HD क्वालिटी में अपने डिवाइस पर सेव करें। कोई वॉटरमार्क नहीं, कोई साइन-अप नहीं, किसी भी डिवाइस पर तुरंत काम करता है।",
    metaDesc: "इंस्टाग्राम रील्स मुफ्त में HD क्वालिटी में डाउनलोड करें। कोई वॉटरमार्क नहीं, कोई लॉगिन जरूरी नहीं। InstantSaver से सेकंडों में रील्स सेव करें।",
    keywords: "instagram reels downloader, instagram reels डाउनलोड करें, reels saver, मुफ्त reels download",
    faq: [
      { q: "मैं इंस्टाग्राम रील्स कैसे डाउनलोड करूं?", a: "इंस्टाग्राम पर रील खोलें, तीन-डॉट मेनू (⋯) टैप करें और लिंक कॉपी करें। इसे InstantSaver में पेस्ट करें और Download पर क्लिक करें।" },
      { q: "क्या मैं iPhone पर रील्स डाउनलोड कर सकता हूं?", a: "हां। InstantSaver iPhone पर Safari में काम करता है। डाउनलोड के बाद, वीडियो आपके Files या Photos ऐप में होगा।" },
      { q: "क्या मैं Android पर रील्स डाउनलोड कर सकता हूं?", a: "हां। वीडियो अपने आप आपके डिवाइस के Downloads फ़ोल्डर में सेव हो जाता है।" },
      { q: "क्या डाउनलोड की गई रील्स HD क्वालिटी की होती हैं?", a: "हां। रील्स उनकी मूल रिज़ॉल्यूशन में प्राप्त की जाती हैं — उपलब्ध होने पर 1080p तक।" },
    ],
    featureTitle: "रील्स के लिए InstantSaver क्यों चुनें?",
    features: [
      { icon: "⚡", text: "किसी भी पब्लिक रील को 5 सेकंड से कम में डाउनलोड करें" },
      { icon: "🔇", text: "कोई वॉटरमार्क नहीं — साफ मूल फाइल" },
      { icon: "📱", text: "iPhone, Android, टैबलेट और डेस्कटॉप पर काम करता है" },
      { icon: "🔒", text: "कभी भी लॉगिन या अकाउंट की जरूरत नहीं" },
      { icon: "♾️", text: "असीमित डाउनलोड, कोई दैनिक सीमा नहीं" },
    ],
  },

  "youtube-downloader": {
    title: "YouTube वीडियो डाउनलोडर — YouTube वीडियो मुफ्त डाउनलोड करें",
    h1: "YouTube वीडियो डाउनलोडर",
    desc: "YouTube वीडियो और Shorts मुफ्त में डाउनलोड करें। MP4 वीडियो या ऑडियो सीधे अपने डिवाइस पर सेव करें — तेज़ और आसान।",
    metaDesc: "मुफ्त YouTube वीडियो डाउनलोडर। YouTube वीडियो और Shorts को MP4 या सिर्फ ऑडियो फॉर्मेट में डाउनलोड करें। कोई साइन-अप जरूरी नहीं।",
    keywords: "youtube downloader, youtube वीडियो डाउनलोड करें, youtube shorts downloader, youtube mp4 डाउनलोड करें",
    faq: [
      { q: "मैं YouTube वीडियो कैसे डाउनलोड करूं?", a: "InstantSaver पर YouTube टैब पर जाएं, वीडियो का URL पेस्ट करें, Preview पर क्लिक करें, फिर Download पर क्लिक करें।" },
      { q: "क्या मैं YouTube Shorts डाउनलोड कर सकता हूं?", a: "हां। Shorts का URL पेस्ट करें और InstantSaver डाउनलोड को अपने आप संभाल लेगा।" },
      { q: "डाउनलोड किस क्वालिटी में होता है?", a: "InstantSaver सबसे अच्छी उपलब्ध प्री-मक्स्ड क्वालिटी डाउनलोड करता है, आमतौर पर 720p तक।" },
      { q: "क्या मैं सिर्फ ऑडियो डाउनलोड कर सकता हूं?", a: "हां। वीडियो प्रीव्यू करने के बाद, M4A ऑडियो ट्रैक पाने के लिए Download Audio बटन पर क्लिक करें।" },
    ],
    featureTitle: "YouTube डाउनलोड विकल्प",
    features: [
      { icon: "🎥", text: "MP4 वीडियो — 360p, 480p, 720p विकल्प" },
      { icon: "🎵", text: "सिर्फ ऑडियो M4A डाउनलोड" },
      { icon: "⚡", text: "YouTube Shorts — किसी भी वीडियो जैसा" },
      { icon: "🔒", text: "किसी अकाउंट की जरूरत नहीं" },
      { icon: "📱", text: "मोबाइल और डेस्कटॉप दोनों पर काम करता है" },
    ],
  },

  "profile-picture-downloader": {
    title: "इंस्टाग्राम प्रोफ़ाइल पिक्चर डाउनलोडर — HD प्रोफ़ाइल फोटो सेव करें",
    h1: "इंस्टाग्राम प्रोफ़ाइल पिक्चर डाउनलोडर",
    desc: "किसी की भी इंस्टाग्राम प्रोफ़ाइल पिक्चर पूरे साइज़ में डाउनलोड करें। बस प्रोफ़ाइल URL पेस्ट करें और DP तुरंत सेव करें।",
    metaDesc: "इंस्टाग्राम प्रोफ़ाइल पिक्चर (DP) मूल क्वालिटी में डाउनलोड करें। किसी भी पब्लिक इंस्टाग्राम प्रोफ़ाइल का URL पेस्ट करें और फोटो मुफ्त में सेव करें।",
    keywords: "instagram profile picture downloader, instagram dp downloader, instagram profile photo डाउनलोड करें",
    faq: [
      { q: "मैं इंस्टाग्राम प्रोफ़ाइल पिक्चर कैसे डाउनलोड करूं?", a: "इंस्टाग्राम प्रोफ़ाइल पर जाएं, URL कॉपी करें (जैसे instagram.com/username), इसे InstantSaver में पेस्ट करें, और Download Profile Picture पर क्लिक करें।" },
      { q: "क्या मैं प्राइवेट अकाउंट की प्रोफ़ाइल पिक्चर डाउनलोड कर सकता हूं?", a: "नहीं। बिना लॉगिन सिर्फ पब्लिक अकाउंट की प्रोफ़ाइल पिक्चर ही एक्सेस की जा सकती है।" },
      { q: "क्या डाउनलोड की गई फोटो फुल-साइज़ वर्जन है?", a: "InstantSaver इंस्टाग्राम के पब्लिक CDN से उपलब्ध सबसे अच्छी क्वालिटी की इमेज डाउनलोड करता है।" },
      { q: "डाउनलोड की गई प्रोफ़ाइल पिक्चर किस फॉर्मेट में होती है?", a: "प्रोफ़ाइल पिक्चर JPEG फाइल के रूप में सेव होती हैं।" },
    ],
    featureTitle: "यह कैसे काम करता है",
    features: [
      { icon: "👤", text: "किसी भी पब्लिक इंस्टाग्राम अकाउंट के लिए काम करता है" },
      { icon: "🖼️", text: "उपलब्ध सबसे अच्छी क्वालिटी डाउनलोड करता है" },
      { icon: "⚡", text: "डाउनलोड से पहले तुरंत प्रीव्यू" },
      { icon: "🔒", text: "कोई लॉगिन नहीं — अनाम और निजी" },
      { icon: "📱", text: "सभी डिवाइस और ब्राउज़र पर काम करता है" },
    ],
  },

  "carousel-downloader": {
    title: "इंस्टाग्राम कैरोसेल डाउनलोडर — सभी कैरोसेल फोटो और वीडियो डाउनलोड करें",
    h1: "इंस्टाग्राम कैरोसेल डाउनलोडर",
    desc: "इंस्टाग्राम कैरोसेल पोस्ट की हर फोटो और वीडियो अलग-अलग या एक क्लिक में सभी एक साथ डाउनलोड करें।",
    metaDesc: "इंस्टाग्राम कैरोसेल पोस्ट की सभी फोटो और वीडियो डाउनलोड करें। हर आइटम अलग से सेव करें या Download All का उपयोग करें। मुफ्त, तेज़, बिना वॉटरमार्क।",
    keywords: "instagram carousel downloader, instagram carousel डाउनलोड करें, instagram multiple photos download",
    faq: [
      { q: "क्या मैं सभी कैरोसेल इमेज एक साथ डाउनलोड कर सकता हूं?", a: "हां। कैरोसेल URL पेस्ट करने के बाद, InstantSaver हर आइटम को अलग डाउनलोड बटन के साथ और एक \"Download All\" बटन के साथ दिखाता है।" },
      { q: "अगर कैरोसेल में वीडियो और फोटो मिक्स हों तो क्या होगा?", a: "InstantSaver हर आइटम के टाइप को अपने आप पहचान लेता है — फोटो JPG में और वीडियो MP4 में सेव होते हैं।" },
      { q: "क्या डाउनलोड कर सकने वाले आइटम की कोई सीमा है?", a: "कोई सीमा नहीं। InstantSaver 20 आइटम तक के कैरोसेल पहचान और डाउनलोड कर सकता है।" },
      { q: "मुझे कैरोसेल लिंक कैसे मिलेगा?", a: "इंस्टाग्राम पर, पोस्ट खोलें, ⋯ टैप करें और Copy Link चुनें। URL में /p/ होता है — यह एक पोस्ट है, जो कैरोसेल हो सकता है।" },
    ],
    featureTitle: "कैरोसेल डाउनलोड फीचर्स",
    features: [
      { icon: "🗂️", text: "सभी कैरोसेल आइटम अपने आप पहचानता है" },
      { icon: "⬇️", text: "हर आइटम के लिए अलग डाउनलोड बटन" },
      { icon: "📦", text: "एक-क्लिक में सभी सेव करने के लिए Download All बटन" },
      { icon: "🎬", text: "मिक्स फोटो + वीडियो कैरोसेल को संभालता है" },
      { icon: "✨", text: "डाउनलोड से पहले थंबनेल प्रीव्यू" },
    ],
  },

  "stories-downloader": {
    title: "इंस्टाग्राम स्टोरी डाउनलोडर — स्टोरी गायब होने से पहले सेव करें",
    h1: "इंस्टाग्राम स्टोरी डाउनलोडर",
    desc: "किसी भी पब्लिक इंस्टाग्राम स्टोरी — फोटो या वीडियो — को 24 घंटे में गायब होने से पहले अपने डिवाइस पर सेव करें। कोई लॉगिन जरूरी नहीं।",
    metaDesc: "इंस्टाग्राम स्टोरी मुफ्त में डाउनलोड करें। पब्लिक स्टोरी फोटो और वीडियो उनके गायब होने से पहले सेव करें। कोई लॉगिन नहीं, कोई वॉटरमार्क नहीं।",
    keywords: "instagram story downloader, instagram story डाउनलोड करें, instagram story saver",
    faq: [
      { q: "मैं इंस्टाग्राम स्टोरी कैसे डाउनलोड करूं?", a: "इंस्टाग्राम पर स्टोरी खोलें, उसका लिंक (या प्रोफ़ाइल लिंक) कॉपी करें, इसे InstantSaver में पेस्ट करें, और Download पर क्लिक करें।" },
      { q: "क्या मैं स्टोरी अनाम रूप से डाउनलोड कर सकता हूं?", a: "हां। InstantSaver बिना लॉगिन किए पब्लिक स्टोरी प्राप्त करता है, और अकाउंट के मालिक को सूचित नहीं किया जाता।" },
      { q: "क्या मैं प्राइवेट अकाउंट से स्टोरी डाउनलोड कर सकता हूं?", a: "नहीं। बिना लॉगिन सिर्फ पब्लिक अकाउंट की स्टोरी ही एक्सेस की जा सकती हैं।" },
      { q: "स्टोरी गायब होने के बाद क्या होता है?", a: "एक बार स्टोरी इंस्टाग्राम से गायब हो जाए (24 घंटे बाद, जब तक Highlight के रूप में सेव न हो), InstantSaver उसे प्राप्त नहीं कर सकता — उससे पहले डाउनलोड कर लें।" },
    ],
    featureTitle: "स्टोरी के लिए InstantSaver क्यों इस्तेमाल करें",
    features: [
      { icon: "⏱️", text: "24 घंटे की समय सीमा से पहले स्टोरी सेव करें" },
      { icon: "🙈", text: "अनाम — पोस्ट करने वाले को कभी सूचित नहीं किया जाता" },
      { icon: "🎬", text: "फोटो और वीडियो दोनों तरह की स्टोरी के लिए काम करता है" },
      { icon: "🔒", text: "कोई लॉगिन या अकाउंट जरूरी नहीं" },
      { icon: "📱", text: "iPhone, Android और PC पर काम करता है" },
    ],
  },

  "highlights-downloader": {
    title: "इंस्टाग्राम हाइलाइट्स डाउनलोडर — सेव की गई स्टोरी हाइलाइट्स डाउनलोड करें",
    h1: "इंस्टाग्राम हाइलाइट्स डाउनलोडर",
    desc: "किसी पब्लिक इंस्टाग्राम प्रोफ़ाइल की स्टोरी हाइलाइट्स — प्रोफ़ाइल पर पिन की गई सेव स्टोरी — से वीडियो और फोटो डाउनलोड करें।",
    metaDesc: "इंस्टाग्राम हाइलाइट्स मुफ्त में डाउनलोड करें। किसी पब्लिक प्रोफ़ाइल की पिन की गई स्टोरी हाइलाइट्स से अलग-अलग फोटो और वीडियो सेव करें।",
    keywords: "instagram highlights downloader, instagram highlights डाउनलोड करें, instagram highlight saver",
    faq: [
      { q: "इंस्टाग्राम हाइलाइट्स क्या हैं?", a: "हाइलाइट्स वे स्टोरी हैं जिन्हें किसी यूज़र ने अपनी प्रोफ़ाइल पर स्थायी रूप से पिन रखने के लिए चुना है, जो नाम वाले कलेक्शन में समूहित होती हैं।" },
      { q: "मैं हाइलाइट कैसे डाउनलोड करूं?", a: "प्रोफ़ाइल पर हाइलाइट खोलें, उसका लिंक कॉपी करें, इसे InstantSaver में पेस्ट करें, और Download पर क्लिक करें।" },
      { q: "क्या मैं हाइलाइट के सभी आइटम एक साथ डाउनलोड कर सकता हूं?", a: "हां, जहां इंस्टाग्राम इसकी अनुमति देता है — InstantSaver हर स्लाइड को अपने डाउनलोड बटन के साथ दिखाता है।" },
      { q: "क्या मुझे हाइलाइट्स डाउनलोड करने के लिए अकाउंट को फॉलो करना होगा?", a: "नहीं, जब तक अकाउंट पब्लिक है।" },
    ],
    featureTitle: "हाइलाइट्स डाउनलोड फीचर्स",
    features: [
      { icon: "📌", text: "किसी भी पब्लिक प्रोफ़ाइल की पिन की गई हाइलाइट्स पर काम करता है" },
      { icon: "🎞️", text: "अलग-अलग फोटो और वीडियो स्लाइड डाउनलोड करता है" },
      { icon: "🔒", text: "कोई लॉगिन या अकाउंट जरूरी नहीं" },
      { icon: "📱", text: "iPhone, Android और PC पर काम करता है" },
    ],
  },
};
